import { render } from "./mshelGallery.vue?vue&type=template&id=1e60dac8&scoped=true"
import script from "./mshelGallery.vue?vue&type=script&lang=js"
export * from "./mshelGallery.vue?vue&type=script&lang=js"

import "./mshelGallery.vue?vue&type=style&index=0&id=1e60dac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e60dac8"]])

export default __exports__